import { useStudentsList } from "../hooks/useStudentsList";
import React from "react";
import { StudentModelProps, StudentRequestProps } from "../../types";

const StudentsLists = ({
  requestStudents,
  setToggleForm,
  setClickedStudentIndex,
  setUpdatingStudentId,
  students,
}: {
  requestStudents: StudentRequestProps[];
  setToggleForm: (type: "add" | "update", triggered: boolean) => void;
  setClickedStudentIndex: React.Dispatch<React.SetStateAction<number>>;
  setUpdatingStudentId: React.Dispatch<React.SetStateAction<number>>;
  students: StudentModelProps[];
}) => {
  const [studentElements] = useStudentsList(requestStudents, students);
  return (
    <>
      {studentElements.map((studentElement, index) => (
        <studentElement.element
          {...studentElement.props}
          key={index}
          setClickedStudentIndex={setClickedStudentIndex}
          setToggleForm={setToggleForm}
          setUpdatingStudentId={setUpdatingStudentId}
        />
      ))}
    </>
  );
};

export default StudentsLists;
